import logo from "./logo.svg";
import "./App.css";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { Home } from "./components/home";
import { Network } from "./components/network";
import { Login } from "./components/login/login";
import { AthleteDashboard } from "./components/dashboard/athlete/dashboard";
import { AddGallery } from "./components/dashboard/athlete/gallery";

function App() {
  return (
    <HashRouter>
      <Network />
      <Routes>
        <Route path="/" exact element={<Navigate to="/login" />} />
        <Route path="/albums"  element={<Home />} />
        <Route path="/login" exact={true} element={<Login />} />
        <Route path="/dashboard" element={<AthleteDashboard />} />
        <Route path="/gallery" element={<AddGallery />} />

      </Routes>
    </HashRouter>
  );
}

export default App;
